export default __webpack_public_path__ + "static/media/transition.53b9ec9c.mp3";